import React, { useState, useEffect, useRef } from 'react';

import { RideButton, RideGlInformationSolid } from '@rimac-seguros/ride-system-components';

import { DpsQuestions } from '../../../../utils/constants';
import {
  Checkbox,
  Radio,
  Input,
} from '../../../../components/atoms';
import {
  capitalize,
  verifyHeight,
  verifyWeight,
  getErrorPage,
} from '../../../../utils/helpers';
import { useAppContext } from '../../../../AppProvider';
import {
  validateIMC,
  registerLead,
  registerDps,
  validateSubscriptionDps,
  abortRequest,
} from '../../../../services/clientServices';
import { getTagActionName } from '../../../../utils/analytics';
import ModalImageInfo from '../../../../modules/step-dps/modal-image-info';
import RegisterAuditory from '../../../../auditory/component/RegisterAuditory';
import { AUDITORY_MODEL } from '../../../../models/step-dps';
import { requestDps } from '../../../../services/requests';
import { useHistory } from '../../../../hooks/useHistory';

const StepDps = () => {
  const [disabledButton, setDisabledButton] = useState(true);
  const [checkValue, setCheckValue] = useState(false);
  const [errorMeasures, setErrorMeasures] = useState(false);
  const {
    state: {
      client,
      leadData,
      idQuote,
      subscriptionQuote,
    },
    state,
    dispatch,
  } = useAppContext();
  const [loading, setLoading] = useState(false);
  const { navigate } = useHistory();

  const [modalQ1, setModalQ1] = useState(false);
  const [modalQ4, setModalQ4] = useState(false);
  const [modalQ5, setModalQ5] = useState(false);

  const registerDpsController = useRef({ signal: null, abort: abortRequest });
  const registerLeadController = useRef({ signal: null, abort: abortRequest });
  const validateIMCController = useRef({ signal: null, abort: abortRequest });

  const insuredData = [
    {
      codExterno: client.tercero,
      fecNacimiento: client.fechaNacimiento,
      gender: client.sexo,
      idGender: client.sexo,
      idParentesco: 0,
      indExisteTercero: true,
      lastname1: client.apellidoPaterno,
      lastname2: client.apellidoMaterno,
      mail: client.correo,
      name: client.nombres,
      names: client.nombres,
      numDocument: client.numeroDocumento,
      parentesco: 'TITULAR',
      telefono: client.telefono,
      typeDocument: client.tipoDocumento,
    },
  ];
  // 1,4,5,6,7,8
  const dpsSingular = ['P01', 'P04', 'P05', 'P06', 'P07', 'P08'];
  const formData = () => {
    const data = [];
    DpsQuestions.forEach((e) => {
      if (e.id === 'P03') {
        const answerP03 = [];
        insuredData.forEach((i) => {
          answerP03.push({
            idParentesco: i.parentesco,
            estatura: '',
            peso: '',
          });
        });
        data.push({
          id: e.id,
          question: insuredData.length === 1
            && dpsSingular.includes(e.id)
            ? e.questionSingular : e.question,
          answer: answerP03,
        });
      } else {
        data.push({
          id: e.id,
          question: insuredData.length === 1
            && dpsSingular.includes(e.id)
            ? e.questionSingular : e.question,
          answer: '',
        });
      }
    });
    return data;
  };

  const [answers, setAnswers] = useState(formData());
  useEffect(() => {
    const answersToEvaluate = [...answers];
    answersToEvaluate.splice(6, 1);
    if (checkValue && !errorMeasures) {
      if (answersToEvaluate.some((e) => e.answer === '')) setDisabledButton(true);
      else setDisabledButton(false);
      answersToEvaluate[2].answer.map((item) => {
        if (item.estatura === '' || item.peso === '') setDisabledButton(true);
        return true;
      });
    } else setDisabledButton(true);
  }, [checkValue, answers]);

  useEffect(() => () => {
    registerDpsController.current?.abort(registerDpsController.current?.signal);
    registerLeadController.current?.abort(registerLeadController.current?.signal);
    validateIMCController.current?.abort(validateIMCController.current?.signal);
  }, []);

  const newArray = [];

  const reviewStats = (answer, value, id, msr) => {
    const newAnswer = [];
    answer.forEach((item, i) => {
      newAnswer.push({
        idParentesco: item.idParentesco,
        estatura: id === i && msr === 0 ? value : item.estatura,
        peso: id === i && msr === 1 ? value : item.peso,
      });
    });
    return newAnswer;
  };

  const setValue = (value, id, msr) => {
    answers.forEach((el) => {
      if (el.id === 'P03') {
        newArray.push({
          id: el.id,
          question: el.question,
          answer: reviewStats(el.answer, value, id, msr),
        });
      } else {
        newArray.push({
          id: el.id,
          question: el.question,
          answer: el.id === id ? value : el.answer,
        });
      }
    });
    setAnswers(newArray);
  };

  function handleValidate() {
    setLoading(true);
    const questionOpenRestriction = DpsQuestions
      .filter(({ indOpenRestrictionDigital }) => Boolean(indOpenRestrictionDigital))
      .map(({ id }) => id);
    const auxOpenRestriction = answers.some((elem) => elem.answer?.toUpperCase?.() === 'SI' && questionOpenRestriction.includes(elem.id));
    if (answers.some((e) => e.answer === 'SI' && !questionOpenRestriction.includes(e.id))) {
      return navigate('/comprar/seguro-salud-flexible/declaracion-salud/gracias');
    }
    const request = {
      afiliados: [{
        fecNacimiento: client.fechaNacimiento,
        tipDocumento: client.tipoDocumento.toString(),
        numDocumento: client.numeroDocumento,
        peso: parseFloat(answers[2].answer[0].peso, 10),
        talla: parseFloat(answers[2].answer[0].estatura, 10),
      }],
    };
    const requestLead = leadData;
    requestLead.finalizado = 4;
    registerLead(requestLead, (signal) => {
      registerLeadController.current.signal = signal;
    })
      .then(() => {
        dispatch({ type: 'ADD_LEAD_DATA', payload: requestLead });

        // eslint-disable-next-line
        const answerResult = answers.map((e) => e.answer = (e.answer === true ? 'SI' : e.answer === false ? 'NO' : e.answer));
        dispatch({ type: 'SAVE_DPS', payload: { answers: answerResult, insured: request.afiliados } });
        validateIMC(request, (signal) => {
          validateIMCController.current.signal = signal;
        })
          .then((response) => {
            const dataResponse = response?.payload?.payload?.rptaValidateIMC;
            // eslint-disable-next-line no-plusplus
            for (let e = 0; e < dataResponse.length; e++) {
              if (dataResponse[e].indValidacion === 1) {
                return navigate('/comprar/seguro-salud-flexible/declaracion-salud/gracias');
              }
            }
            navigate('/comprar/seguro-salud-flexible/direccion');
          })
          .catch((error) => navigate && navigate(getErrorPage(error, 'VALIDAR_IMC')));
      })
      .catch((error) => navigate && navigate((getErrorPage(error, 'AGREGAR_LEADS'))));

    if (auxOpenRestriction || subscriptionQuote) {
      registerDps(requestDps({
        ...state,
        dps: {
          ...state.dps,
          answers: answers.map((e) => e.answer),
        },
      }), (signal) => {
        registerDpsController.current.signal = signal;
      })
        .then(async () => {
          const product = state.planSelected?.codPlan || '';
          const plan = state.planSelected?.nroPlan || '';
          const { payload } = await validateSubscriptionDps({
            generarPDS: {
              ideCotizacion: idQuote,
              producto: '3844',
              productName: product !== '' ? `${product} - ${plan}` : '',
              nroPlan: plan,
              estadoRegistro: auxOpenRestriction ? 'SIN_RESTRICCION_FUMADORES' : 'CAMBIO_HAPPY_PATH',
            },
          });
          const { indValidacion } = payload.payload;
          if (indValidacion) {
            dispatch({ type: 'SET_QUOTATION_QUOTE', payload: idQuote });
          }
        });
    }
  }

  useEffect(() => {
    // getTagVirtual('sol:comprar:seguro-salud-flexible:declaracion-salud');
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 2);
  }, []);

  const openModalByQuestion = (questionId) => {
    if (questionId === 'P01') {
      setModalQ1(true);
      getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Click', 'Conoce por qué te lo preguntamos', 'trackAction');
    } else if (questionId === 'P04') {
      setModalQ4(true);
      getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Click', 'Lista de enfermedades crónicas', 'trackAction');
    } else if (questionId === 'P05') {
      setModalQ5(true);
      getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Click', 'Lista de enfermedades severas', 'trackAction');
    }
  };

  return (
    <>
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <div className="step-container dps">
        <div className="container">
          <div className="dps-content">
            <div className="dps-content__title">
              Conversemos sobre tu salud
            </div>
            <div className="dps-content__subtitle">
              Queremos darte una protección a tu medida.
            </div>
            <div className="dps-content__questions">
              {DpsQuestions.map((q, i) => (
                <div key={`dps-${i}`} className="dps-questions__item">
                  <h4>
                    {insuredData.length === 1
                      && dpsSingular.includes(q.id)
                      ? q.questionSingular : q.question}
                    {q.modalTextInfo
                      ? (
                        <div style={{ marginLeft: 3.3, marginBottom: -2 }} className="relative inline-block tooltipInfo tooltipTC-on-hover">
                          <RideGlInformationSolid size="medium" />
                          <div className="tooltipInfo-text tooltipTC custom-tooltip-dps">
                            Marca “Sí” si has tenido cualquier tipo de seguro privado de salud,
                            haya sido contratado por tu empleador (como por ejemplo, una EPS)
                            o por ti directamente.
                          </div>
                        </div>
                      )
                      : ''}
                  </h4>
                  <span className="addInfo">{q.addInfo}</span>
                  <span className="link__text" onClick={() => openModalByQuestion(q.id)}>{q.addLink}</span>
                  {
                    q.type === 't2'
                      ? (
                        <div className="content-inputs wo-mg">
                          {
                            insuredData.map((insured, j) => (
                              <div key={`insured-${j}`} className="insured-item">
                                <div className="title">
                                  {capitalize(insured.parentesco)}
                                  {' - '}
                                  {capitalize(insured.name)}
                                </div>
                                <div className="inputs">
                                  <Input
                                    label="Estatura (m)"
                                    type="text"
                                    value={answers[i].answer[j].estatura}
                                    tooltipText="Por ejemplo: 1.60"
                                    onChange={(value) => {
                                      setValue(value, j, 0);
                                      setErrorMeasures(!verifyHeight(value));
                                    }}
                                  />
                                  <Input
                                    label="Peso (kg)"
                                    type="text"
                                    value={answers[i].answer[j].peso}
                                    tooltipText="Por ejemplo: 60"
                                    onChange={(value) => {
                                      setValue(value, j, 1);
                                      setErrorMeasures(!verifyWeight(value));
                                    }}
                                    maxLength="3"
                                  />
                                </div>
                              </div>
                            ))
                          }
                          {
                            errorMeasures ? <div className="message-error">* Complete correctamente los campos de peso y talla</div> : ''
                          }
                        </div>
                      )
                      : (
                        <div className="content-inputs">
                          <Radio
                            value="SI"
                            label="Sí"
                            onClick={(value) => setValue(value, q.id)}
                            checked={answers[i].answer}
                            specialClass="mg-16"
                          />
                          <Radio
                            value="NO"
                            label="No"
                            onClick={(value) => setValue(value, q.id)}
                            checked={answers[i].answer}
                          />
                        </div>
                      )
                  }
                </div>
              ))}
              <div className="dps-content__check">
                <Checkbox
                  checked={checkValue}
                  label="Declaro como verdadera la información brindada sobre mi estado de salud."
                  onChange={(value) => {
                    setCheckValue(value);
                  }}
                />
              </div>
              <div className="dps-content__btn">
                <RideButton
                  loading={loading}
                  type="primary"
                  text="Continuar"
                  size="x-large"
                  disabled={disabledButton}
                  onClick={() => handleValidate()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {modalQ1 && (
        <ModalImageInfo
          title={DpsQuestions[0].modalInfo.title}
          image={DpsQuestions[0].modalInfo.image}
          text={DpsQuestions[0].modalInfo.detail}
          cancelEvent={() => setModalQ1(false)}
          actionEvent={() => setModalQ1()}
          onClose={() => setModalQ1(false)}
        />
      )}
      {modalQ4 && (
        <ModalImageInfo
          title={DpsQuestions[3].modalInfo.title}
          image={DpsQuestions[3].modalInfo.image}
          diseasesList={DpsQuestions[3].modalInfo.diseasesList}
          cancelEvent={() => setModalQ4(false)}
          actionEvent={() => setModalQ4()}
          onClose={() => setModalQ4(false)}
        />
      )}
      {modalQ5 && (
        <ModalImageInfo
          title={DpsQuestions[4].modalInfo.title}
          image={DpsQuestions[4].modalInfo.image}
          diseasesList={DpsQuestions[4].modalInfo.diseasesList}
          cancelEvent={() => setModalQ5(false)}
          actionEvent={() => setModalQ5()}
          onClose={() => setModalQ5(false)}
        />
      )}
    </>
  );
};

export default StepDps;
